export default __webpack_public_path__ + "static/media/focus-incorrect1.d52f0740.PNG";